<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <div class="cell shrink grid-x grid-padding-x grid-padding-y">
    <table class="cell small-12">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.sales.detail.menus.number'"></th>
            <th></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'menu.a.la.carte.dishes'"></td>
            <td class="_number">{{study.aLaCarteSales | number:'1.0'}}</td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.FIRST_COURSE_MAIN_COURSE'"></td>
            <td class="_number">{{study.firstCourseMainCourseMenuSales | number:'1.0'}}</td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.MAIN_COURSE_DESSERT'"></td>
            <td class="_number">{{study.mainCourseDessertMenuSales | number:'1.0'}}</td>
        </tr>
        <tr>
            <td [i18nKey]="'menu.FULL_COURSE'"></td>
            <td class="_number">{{study.fullCourseSales | number:'1.0'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.total'"></td>
            <td class="_number _totalColumn">{{study.coversNumber | number:'1.0'}}</td>
        </tr>
        </tbody>
    </table>

    <table class="cell small-12">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.sales.detail.wine.bottles.number'"></th>
            <th></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr *ngFor="let wineName of study.winesSales | keys">
            <td>{{('menu.' + wineName) | translate}}</td>
            <td class="_number">{{study.winesSales[wineName] | number:'1.0'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.total'"></td>
            <td class="_number _totalColumn">{{study.totalWinesSales | number:'1.0'}}</td>
        </tr>
        </tbody>
    </table>

    <table class="cell small-12">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.sales.detail.total.dishes.number'"></th>
            <th></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr *ngFor="let firstCourseName of study.firstCoursesTotalSales | keys">
            <td>{{('menu.' + firstCourseName) | translate}}</td>
            <td class="_number">{{study.firstCoursesTotalSales[firstCourseName] | number:'1.0'}}</td>
        </tr>
        <tr *ngFor="let mainCourseName of study.mainCoursesTotalSales | keys">
            <td>{{('menu.' + mainCourseName) | translate}}</td>
            <td class="_number">{{study.mainCoursesTotalSales[mainCourseName] | number:'1.0'}}</td>
        </tr>
        <tr *ngFor="let dessertName of study.dessertsTotalSales | keys">
            <td>{{('menu.' + dessertName) | translate}}</td>
            <td class="_number">{{study.dessertsTotalSales[dessertName] | number:'1.0'}}</td>
        </tr>
        <tr>
            <td class="_totalColumn"[i18nKey]="'common.total'"></td>
            <td class="_number _totalColumn">{{study.totalDishesSales | number:'1.0'}}</td>
        </tr>
        </tbody>
    </table>

        <table class="cell small-12">
            <thead>
            <tr class="_titlePartTable">
                <th [i18nKey]="'studies.sales.detail.a.la.carte.dishes.number'"></th>
                <th></th>
            </tr>
            </thead>

            <kiwi-spacer [size]="16"></kiwi-spacer>

            <tbody>
            <tr *ngFor="let firstCourseName of study.firstCoursesALaCarteSales | keys">
                <td>{{'menu.' + firstCourseName | translate}}</td>
                <td class="_number">{{study.firstCoursesALaCarteSales[firstCourseName] | number:'1.0'}}</td>
            </tr>

            <tr *ngFor="let mainCourseName of study.mainCoursesALaCarteSales | keys">
                <td>{{'menu.' + mainCourseName | translate}}</td>
                <td class="_number">{{study.mainCoursesALaCarteSales[mainCourseName] | number:'1.0'}}</td>
            </tr>

            <tr *ngFor="let dessertName of study.dessertsALaCarteSales | keys">
                <td>{{'menu.' + dessertName | translate}}</td>
                <td class="_number">{{study.dessertsALaCarteSales[dessertName] | number:'1.0'}}</td>
            </tr>

            <tr>
                <td class="_totalColumn"[i18nKey]="'common.total'"></td>
                <td class="_totalColumn _number">{{study.totalALaCarteSales | number:'1.0'}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
